import React, { useEffect, useState } from 'react';
import { MenuItem, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import Select from 'components/common/Select';
import useClassrooms from 'state/hooks/use-classrooms';
import useAssignments from 'state/hooks/use-assignments';
import { GroupTypes } from 'state/providers/AssignmentsProvider/types';
import { getSortedValues } from '../utils';

const AssignmentFilter: React.FC = () => {
  const classes = useStyles();
  const [values, setValues] = useState<string[]>([]);
  const [{ activeClassroom }] = useClassrooms();
  const [{ groupFilter }, { setGroupFilter }] = useAssignments();

  useEffect(() => {
    if (!activeClassroom?.groups?.length) return;
    const { groups } = activeClassroom;
    const onlyOneGroup = groups?.length === 1;
    const groupNames = groups?.map((group) => group.name);
    const groupValues = onlyOneGroup ? groupNames : [GroupTypes.ALL, ...groupNames];

    if (onlyOneGroup) setGroupFilter(groupNames[0]);

    const sortedValues = getSortedValues(groupValues);

    setValues(sortedValues);
  }, [activeClassroom]);

  const handleChange = (e) => {
    const { value } = e.target;
    setGroupFilter(value);
  };

  const renderValue = () => groupFilter;
  return (
    <div className={classes.container}>
      Filter By:
      <Select value={groupFilter} renderValue={renderValue} onChange={handleChange}>
        {values.map((item) => (
          <MenuItem key={item} value={item as any}>
            <Typography className={classes.menuItem}>{item}</Typography>
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    width: remCalc(224),
    color: '#202020',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: remCalc(16),
    fontWeight: 400,
    lineHeight: '18px',
    paddingTop: '10px',
    paddingBottom: '15px',
    marginRight: '10px',
  },
  menuItem: {
    fontFamily: FONT_GSS_FUTURA,
    fontSize: remCalc(16),
  },
}));

export default AssignmentFilter;
